export default __webpack_public_path__ + "asset/img/icon-tip~67415bc2.png";